import React, { useEffect, useContext } from "react";
import { NavLink, useLocation } from 'react-router-dom';
import { Row, Col } from "react-bootstrap";
import { getCDNImage } from '../globals';
import { i18nValue, getPluralKey } from '../functions';
import { T, TF } from "react-translator-component";
import { useNavigate } from "react-router";
import { HotelContext } from "../context/hotel";

const CardList = ({ data, language, entity, relativePath = null }) => {

    const { data: { code: hotelCode } } = useContext(HotelContext);

    useEffect(() => {
        console.log('27ene - items', data);
        if (data) {
            saveChildrenToLocalStorage(data);
        }
    }, [data]);

    const saveChildrenToLocalStorage = (data) => {
        data.forEach((item) => {
            if (item.children && item.children.length > 0) {
                // Recorrer hijos recursivamente
                saveChildrenToLocalStorage(item.children);
            }

            // Guardar el elemento actual en localStorage si tiene un parent
            // if (item.parentId) {
            console.log('27ene guardo', `ViCo::children-${item.id}`)
            localStorage.setItem(`ViCo::children-${item.id}`, JSON.stringify(item));
            //}
        });
    }

    return (
        <div className="generic-card-list row">
            {data && data.length > 0 && data.map((item) => {
                return <CardItem key={item.id} item={item} language={language} entity={entity} hotelCode={hotelCode} relativePath={relativePath} />
            })}
            {!data && data.length === 0 && <p>Sin datos</p>}
        </div>
    )
}

const CardItem = ({ item, language, entity, hotelCode, relativePath = null }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    console.log('item', item);
    console.log('entity', entity);
    let subtitle = [];
    let btnReservationId = null;
    if (entity === "rooms") {
        if (item.m2) subtitle.push(`${item.m2}m2`)
        if (item.persons) subtitle.push(TF(`general.guests.${getPluralKey(item.persons)}`, [item.persons]))
        if (item.individualBeds) subtitle.push(TF(`general.single.beds.${getPluralKey(item.individualBeds)}`, [item.individualBeds]))
        if (item.doubleBeds) subtitle.push(TF(`general.double.beds.${getPluralKey(item.doubleBeds)}`, [item.doubleBeds]))
    }
    if (entity === "restaurants") {
        btnReservationId = item?.bookableItemId;
    }
    if (subtitle.length > 0) {
        subtitle = subtitle.join(', ');
    } else {
        subtitle = false;
    }
    console.log('subtitle', subtitle)

    let auxPath = item.id;
    if (relativePath) {
        auxPath = `../${relativePath}/${item.id}`;
    }

    const handleOpenBookableItemId = (e, id) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(`/${hotelCode}/public/booking/${id}/restaurants`, { replace: true });
    }

    return (
        <div className="col-12 col-md-6 col-lg-4">
            <Row>
                <Col>
                    <NavLink style={{ color: 'black', width: '100%', textDecoration: 'none' }} to={{ pathname: auxPath, id: item.id }} state={{ from: pathname }} >
                        <div className="generic-card">
                            <div className="generic-card-img" style={{ backgroundImage: "url(" + getCDNImage(item.photo) + ")" }}>
                                {/* <AmplifyS3Image  path={val.photo} style={{"--height": "200px", "--width": "100%", borderRadius: '4px'}} /> */}
                            </div>
                            {/* {statusClass &&  val.status != null ? <div className={["request-card-status" +' '+ statusClass]}>{val.status}</div> : null } */}
                            <div className="generic-card-body">

                                {btnReservationId && (
                                    <button
                                        className="btn btn-secondary btn-booking-book"
                                        onClick={(e) => handleOpenBookableItemId(e, btnReservationId)}
                                        style={{
                                            float: 'right',
                                            fontSize: 11,
                                            // color: "#AAA",
                                            // border: '1px solid #DDD',
                                            padding: '2px 10px',
                                            marginTop: '8px'
                                        }}
                                    >{String(T("general.reserve"))?.toUpperCase()}</button>
                                )}

                                {/* {icon ? 
                                <div className="request-card-icon-container">
                                    <div className="request-card-icon">
                                        <FontAwesomeIcon style={{fontSize: "40", top: "0"}} icon={icon}/>
                                    </div>
                                </div>
                            : null } */}
                                <div className="generic-card-title py-2" style={{ textTransform: 'uppercase' }}>{i18nValue(item, 'name', language)}</div>
                                {item.horary && <div className="generic-card-subtitle">{i18nValue(item, 'horary', language)}</div>}
                                {item.capacity && <div className="general-text-sm">{T('meeting_rooms.capacity')} <span className="general-text-bold">{item.capacity} {T('meeting_rooms.people')}</span></div>}
                                {subtitle && <div className="generic-card-subtitle">{subtitle}</div>}

                                {/* <div className="request-card-list-container">
                                { {val.photo ? 
                                    <div>
                                        <AmplifyS3Image path={val.photo} style={{"--height": "100px", "--width": "100%", "border-radius": "10px"}} />
                                    </div>
                                : null} }
                                
                                {val.shodescription ? 
                                <div className="short-description"><span>{val.description}</span></div>
                                : null}
                            </div> */}
                                {/* {val.room ? 
                                <div>
                                    <span className="request-card-room">{val.room}</span>
                                </div>
                            : null}  */}
                            </div>
                        </div>
                    </NavLink>
                </Col>
            </Row>
        </div>
    )
}



export default CardList;